import type {Root as MarkdownRoot} from 'mdast'
import {fromMarkdown} from 'mdast-util-from-markdown'
import {gfmFromMarkdown as mdastGfm} from 'mdast-util-gfm'
import {gfm as micromarkGfm} from 'micromark-extension-gfm'

import {mdastBlankLines} from './extensions/blank-lines'
import {mdastContainDelimiters} from './extensions/contain-delimiters'
import {mdastDelimiters} from './extensions/delimiters'
import {mdastSkipEmptyHeadings} from './extensions/skip-empty-headings'
import {mdastSplitHtml} from './extensions/split-html'

export interface ParseMarkdownOptions {
  enabledExtensions?: {
    delimiters: boolean
    containDelimiters: boolean
    splitHtml: boolean
    skipEmptyHeadings: boolean
    blankLines: boolean
  }
}

export const defaultOptions = {
  enabledExtensions: {
    delimiters: true,
    containDelimiters: true,
    splitHtml: true,
    skipEmptyHeadings: true,
    blankLines: true,
  },
} satisfies ParseMarkdownOptions

export function parseMarkdown(
  markdown: string,
  {enabledExtensions = defaultOptions.enabledExtensions}: ParseMarkdownOptions = defaultOptions,
): MarkdownRoot {
  return fromMarkdown(markdown, 'utf-8', {
    extensions: [micromarkGfm()],
    mdastExtensions: [
      mdastGfm(),
      enabledExtensions.delimiters ? mdastDelimiters() : [],
      enabledExtensions.containDelimiters ? mdastContainDelimiters() : [],
      enabledExtensions.splitHtml ? mdastSplitHtml() : [],
      enabledExtensions.skipEmptyHeadings ? mdastSkipEmptyHeadings() : [],
      enabledExtensions.blankLines ? mdastBlankLines(markdown) : [],
    ],
  })
}
